const isElement = (el: Element | Window) => el instanceof Element;

export default isElement;
